import * as z from "zod";

/**
 * Result of a manual return-shipping payout retry, returned synchronously from
 * the `runPayoutForTeam` workflow's `retryPaymentUpdate` Update so the merchant
 * app can report the real Stripe outcome (e.g. an insufficient-funds decline)
 * instead of a generic "failed to retry" message. `status` mirrors the three
 * Stripe.Charge.Status values the payout flow produces.
 */
export const manualRetryStatusSchema = z.enum([
  "succeeded",
  "pending",
  "failed",
]);
export type ManualRetryStatus = z.infer<typeof manualRetryStatusSchema>;

export const manualRetryResultSchema = z.object({
  status: manualRetryStatusSchema,
  chargeId: z.string().optional(),
  failureMessage: z.string().optional(),
});
export interface ManualRetryResult
  extends z.infer<typeof manualRetryResultSchema> {}
